const Notifications = {
  InviteSuccessDuration: 1800,
  ToastHideDelay: 5000,
};

export default Notifications;
